<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">ML Service Map</p>
      <button class="delete" @click="$emit('close')"></button>
    </header>

    <div class="modal-card-body">
      <template v-if="get_components.length">
        <div class="is-size-5">
          Detection
        </div>
        <div class="modal-card-body--checkboxes">
          <label
            class="checkbox"
            v-for="(val, i) in get_components"
            :key="i"
            :disabled="segmentation.includes(val.name)"
          >
            <input
              type="checkbox"
              :value="val.name"
              v-model="detection"
              :disabled="segmentation.includes(val.name)"
            />
            <span class="checkbox__label">
              {{ val.name }}
            </span>
          </label>
        </div>
        <div class="is-size-5">
          Segmentation
        </div>
        <div class="modal-card-body--checkboxes">
          <label
            class="checkbox"
            v-for="(val, i) in get_components"
            :key="i"
            :disabled="detection.includes(val.name)"
          >
            <input
              type="checkbox"
              :value="val.name"
              v-model="segmentation"
              :disabled="detection.includes(val.name)"
            />
            <span class="checkbox__label">
              {{ val.name }}
            </span>
          </label>
        </div>
      </template>
      <div class="is-size-5 has-text-centered" v-else>
        Add components group in vectors
      </div>
    </div>
    <div class="modal-card-foot" style="justify-content: end">
      <button class="button" @click="$emit('close')">
        Cancel
      </button>
      <button
        class="button is-info"
        @click="saveChanges()"
        :disabled="
          is_training || (detection.length == 0 && segmentation.length == 0)
        "
      >
        Initiate Training
      </button>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import APIService from "@/services/api.service";

export default {
  data() {
    return {
      detection: [],
      segmentation: [],
      is_training: false,
      apiService: new APIService(),
    };
  },
  computed: {
    ...mapState([
      "vectors",
      "draw",
      "active_project",
      "claims",
      "active_layer",
    ]),
    get_components() {
      return [
        ...(this.grouped_vectors["components"] || []),
        ...(this.grouped_vectors["Components"] || []),
      ];
    },
    grouped_vectors() {
      return _.groupBy(this.vectors, "group");
    },
  },
  methods: {
    saveChanges() {
      this.is_training = true;

      if((!this.active_project ||
      !this.active_project.reports ||
      !this.active_project.reports.ortho ||
      !this.active_project.reports.ortho.url)
      ){
          alert("Ortho not present.")
          return;
      }

      const body = {
        class_maps: this.grouped_vectors,
        ml_service_map: {
          detection: this.detection,
          segmentation: this.segmentation,
        },
        train_geojson: this.draw.getAll(),
        data: {
          ortho: this.active_project.reports.ortho.url,
        },
        details: {
          projectUID: this.active_project.projectUid,
          user_email: this.claims.email,
        },
      };
      this.apiService
        .scm_train_data({ body })
        .then((res) => {
          this.$toast.open({
            message: "Successfully queued training.",
            type: "is-success",
          });
          this.is_training = false;
          this.$emit('close');
        })
        .catch((err) => {
          if (!err.response) {
            this.$toast.open({ message: "Network Error", type: "is-danger" });
          } else {
            this.$toast.open({
              message: "Training server turned off",
              type: "is-danger",
            });
          }
          this.is_training = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-card-body {
  &--checkboxes {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 6px;

    .checkbox {
      display: flex;
      align-items: center;
      margin-right: 12px;
      margin-bottom: 6px;

      &__label {
        margin-left: 5px;
      }
    }
  }
}
</style>
